import { DRAWER_MODE_OPTIONS } from "./../../../shared/enums";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GENERIC_STATE_STATUS } from "../../../shared/enums";

const initialState: {
  redirectPath: string;
  state: GENERIC_STATE_STATUS;
  error: { value: boolean; message?: string; code?: string };
  drawerMode: DRAWER_MODE_OPTIONS;
  searchQuery: { value: string; instance: string } | null;
} = {
  redirectPath: "",
  state: GENERIC_STATE_STATUS.PENDING,
  error: { value: false, message: "" },
  drawerMode: DRAWER_MODE_OPTIONS.EXPANDED,
  searchQuery: null,
};

export const appStore = createSlice({
  name: "app-reducer",
  initialState,
  reducers: {
    setRedirectPath(state, action: PayloadAction<string>) {
      return {
        ...state,
        pending: false,
        error: { value: false },
        state: GENERIC_STATE_STATUS.FULFILLED,
        redirectPath: action.payload,
      };
    },
    setDrawerMode(state, action: PayloadAction<DRAWER_MODE_OPTIONS>) {
      return {
        ...state,
        drawerMode: action.payload,
      };
    },
    setSearchQuery(
      state,
      action: PayloadAction<{ value: string; instance: string } | null>
    ) {
      return {
        ...state,
        searchQuery: action.payload,
      };
    },
  },
});

export const { setRedirectPath, setDrawerMode, setSearchQuery } =
  appStore.actions;
